import type { IPort } from "@codesandbox/pitcher-client/dist/esm/interface/clients";
import { usePitcher } from "features/utils/usePitcher";
import { useEffect, useState } from "react";

import { useTasks } from "./useTasks";

export const useUnassignedPorts = () => {
  const pitcher = usePitcher();
  const tasks = useTasks();

  const taskList = Object.values(tasks);
  const allPorts = pitcher.clients.port.getPorts();

  const initialPorts = allPorts.filter(
    (p) => !taskList.some((t) => t.ports.some((tp) => tp.port === p.port)),
  );

  const [ports, setPorts] = useState(initialPorts);

  useEffect(() => {
    const openPortListener = pitcher.clients.task.onUnassignedPortOpened(
      (port) => {
        setPorts([...ports, port]);
      },
    );

    const closedPortListner = pitcher.clients.task.onUnassignedPortClosed(
      (closedPort) => {
        setPorts((ports) => ports.filter((p) => p.port !== closedPort.port));
      },
    );

    const updatePortListener = pitcher.clients.port.onPortsUpdated((ports) => {
      setPorts(ports);
    });

    return () => {
      openPortListener.dispose();
      closedPortListner.dispose();
      updatePortListener.dispose();
    };
  }, []);

  return ignoreVSCodePorts(ports);
};

const VSCODE_SERVER_PORT_RANGE = [50000, 50100];

function ignoreVSCodePorts(ports: IPort[]) {
  return ports.filter(
    ({ port }) =>
      !(
        port >= VSCODE_SERVER_PORT_RANGE[0] &&
        port <= VSCODE_SERVER_PORT_RANGE[1]
      ),
  );
}
